import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../../app.config';
import { WorkQueueDetails } from '../work-queue/work-queue.model';
import { LookupCriteria } from './lookup.model';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  constructor(private httpClient: HttpClient) { }



  lookupByPolicyAndPostalCode(lookupCriterion: LookupCriteria): Observable<WorkQueueDetails> {
    return this.httpClient.post<WorkQueueDetails>(`${AppConfig.settings.settings.apiEndpoint}api/lookup/LookupByPolicyAndPostalCode`, lookupCriterion)
      .pipe(map(data => {
        return data;
      },
        error => {
          return of([]);
        }
      )
      );
  }
}
